import InputAdornment from "@mui/material/InputAdornment";
import Slider from "designSystem/components/slider/Slider";
import React, { useState } from "react";

export default () => {
	const [value, setValue] = useState(10);

	const onChangeValue = (value: number) => {
		setValue(value);
	};

	return (
		<Slider
			includeTextField
			max={100}
			min={0}
			onChange={onChangeValue}
			spacingAround={2}
			step={1}
			textFieldProps={{
				InputProps: {
					endAdornment: <InputAdornment position="end">°</InputAdornment>,
				},
			}}
			value={value}
		/>
	);
};